import React from "react";

const CheckoutLoading = () => (
	<React.Fragment>
		<article className="product-pg loading-article">
			{/* <div className="product-pg-nav">
                <a className="btn-txt btn-white btn-txt-black icon-seta-left btn-icon-left" href="#" >Voltar</a>
            </div> */}

			<div className="product-pg-checkout">
				<div className="pre-info ">
					<ul className="pre-load">
						<li />
					</ul>
				</div>

				<div className="content">
					<ul className="pre-load">
						<li />
						<li />
					</ul>
				</div>

				<div className="summary">
					<ul className="pre-load">
						<li>
							<a
								href="#"
								className="btn-fill btn-gray btn-txt-white icon-seta-right btn-icon-right btn-inactive"
							>
								Finalizar compra
							</a>
						</li>
					</ul>
				</div>
			</div>
		</article>
	</React.Fragment>
);

export default CheckoutLoading;
